export class PostalAddress {
  recipient: string;
  street: string;
  number: string;
  floor?: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  province: string; // spain province enum?
  provinceId: string; // New XA 24/sep/2020 //Update JA 2021/03/15 number -> string
  postalCode: string;
  country: string; // country ISO2. enum country definition?
  phone?: string;
  email?: string;
  organization?: string;
  pickupPointName?: string;
  pickupPointCode?: string;
  shippingCourier?: string;
  taxId?: string;
  dni?: string;
}

export interface ProvinceModel {
  provincia_id: string | number;
  nombre: string;
}

export type AddressType = 'shipping' | 'billing';
export enum Address {
  BILL = 'billingAddress',
  SHIP = 'shippingAddress'
}
